import getMatches from './getMatches'
import saveMitigator from './saveMitigator'

export const getMatchesService = getMatches
export const saveMitigatorService = saveMitigator
